var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBaseProtocolRisk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_829_5062)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128 214C197.312 214 253.5 190.694 253.5 161.945C253.5 133.195 197.312 109.89 128 109.89C58.6883 109.89 2.5 133.195 2.5 161.945C2.5 190.694 58.6883 214 128 214Z",
    fill: "url(#paint0_radial_829_5062)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.4111 49.0166L97.481 119.58L158.63 154.928L164.824 151.354L164.754 80.7901L103.534 45.4908L97.4111 49.0166Z",
    fill: "#8060EA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.1826,
    y: 48.4022,
    width: 71.2989,
    height: 106.819,
    fill: "url(#pattern0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.318 59.4053L152.214 87.5623L152.927 144.456L103.115 115.733L103.318 59.4053Z",
    fill: "url(#paint1_linear_829_5062)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M118.019 124.328L137.206 78.919L152.214 87.5623L134.089 133.599L118.019 124.328Z",
    fill: "#C7ECCA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M106.904 117.919L122.821 70.6318L129.126 74.2692L112.203 120.976L106.904 117.919Z",
    fill: "#C7ECCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.4111 49.0166L103.534 45.4908L164.754 80.7901L164.824 151.354L158.63 154.928V84.3228L97.4111 49.0166Z",
    fill: "#570EE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.4111 147.863C97.8515 147.339 121.988 133.697 121.988 133.697L158.588 154.949L134.088 169.066L97.4111 147.863Z",
    fill: "#8060EA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M121.897 147.863C121.897 147.863 134.081 154.935 134.144 154.928C134.207 154.921 134.144 140.755 134.144 140.755L121.988 133.697L121.897 147.863Z",
    fill: "#570EE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.268 151.396V144.309L134.145 140.755V154.928L140.268 151.396Z",
    fill: "#570EE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.4111 147.863L97.4461 155.389L134.123 176.585L158.623 162.475L158.595 154.949L134.088 169.059L97.4111 147.863Z",
    fill: "#8060EA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M97.4111 147.863L134.088 169.059L134.123 176.585L97.4461 155.389L97.4111 147.863Z",
    fill: "#570EE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.088 169.059L134.123 176.585L158.623 162.475L158.595 154.949L134.088 169.059Z",
    fill: "#570EE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6787 42V84.3647L109.728 112.564L109.581 70.1989L60.6787 42Z",
    fill: "url(#paint2_linear_829_5062)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.2 43.2078L134.13 98.5305L195.363 133.746L195.251 78.4233L134.2 43.2078Z",
    fill: "url(#paint3_linear_829_5062)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_829_5062",
    transform: "scale(0.00980392 0.00653595)"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_829_5062",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(128.031 161.93) scale(125.319 52.0362)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8060EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8060EA",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#8060EA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_829_5062",
    x1: 103.115,
    y1: 101.931,
    x2: 152.927,
    y2: 101.931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88E2A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#9FC0C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C08FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_829_5062",
    x1: 75.6445,
    y1: 93.8108,
    x2: 93.2834,
    y2: 63.2267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C08FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#C08FFF",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C08FFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_829_5062",
    x1: 151.43,
    y1: 110.47,
    x2: 174.49,
    y2: 68.2924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#88E2A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#88E2A1",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#88E2A1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_829_5062"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 208,
    height: 208,
    fill: "white",
    transform: "translate(24 24)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_829_5062",
    width: 102,
    height: 153,
    xlinkHref: "data:image/png;base64,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"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaseProtocolRisk);
export default __webpack_public_path__ + "static/media/base_protocol_risk.a02bd276e4ff0e8c6c81d05bdfb18fd6.svg";
export { ForwardRef as ReactComponent };